module.exports = __webpack_public_path__ + "static/media/certificate-enrolled-2-4.70d70704.svg";